;(function () {
  'use strict'

  angular
    .module('admin.shinie_redemption.service', [])
    .factory('ShinieRedemptionService', ShinieRedemptionService)

  /** @ngInject */
  function ShinieRedemptionService($http, $q, API) {
    function list(startDate, endDate, userId, type) {
      var defered = $q.defer()

      $http
        .get(
          API.API_URL +
            'admin/shinies/track?start-date=' +
            startDate +
            '&end-date=' +
            endDate +
            '&userId=' +
            userId +
            '&type=' +
            type,
        )
        .success(defered.resolve)

      return defered.promise
    }

    return {
      list: list,
    }
  }
})()
